import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { SupplierCard } from 'entities/Supplier/ui/SupplierCard/SupplierCard';

import { useSuppliers } from '../lib';

export const SupplierDetails = () => {
    const { t } = useTranslation();
    const suppliers = useSuppliers();

    const renderContent = () => {
        if (suppliers.length === 0) {
            return (
                <Typography variant="body2" fontSize="1.4rem" color="grey.600">
                    {t('No supplier information available')}
                </Typography>
            );
        }

        return (
            <Box>
                {suppliers.map((supplier) => (
                    <SupplierCard
                        data-testclass="supplier-card"
                        key={supplier.sellerUid}
                        supplierInfo={supplier}
                    />
                ))}
            </Box>
        );
    };

    return (
        <Box sx={{ flex: 1 }}>
            <Typography variant="h4" mb="20px">
                {t('Supplier details')}
            </Typography>

            {renderContent()}
        </Box>
    );
};
